import { format } from "date-fns";
import { DateTime } from "luxon";
import { getTimeZoneFromSwaStation } from "./timeZoneService";

export function padTime(timeInt) {
  if (timeInt < 10) {
    return "0" + timeInt.toString();
  }
  return timeInt.toString();
}

export function getShiftTime(shift) {
  return padTime(shift.hour) + ":" + padTime(shift.minute);
}

export function getShiftDate(shift) {
  return shift.toFormat("MM/dd/yyyy");
}

export function getIsoDateFormat(luxonDate) {
  return luxonDate.toFormat("yyyy-MM-dd");
}

export const getISODateTimeString = (luxonDateTime) => {
  return luxonDateTime.toISO({ includeOffset: false, suppressMilliseconds: true });
};

export const convert_Timestamp_To_Luxon = (timestamp, station) => {
  const date = new Date(parseInt(timestamp));
  const luxonDate = convert_DateFns_To_Luxon(date).setZone(getTimeZoneFromSwaStation(station), {
    keepLocalTime: true,
  });
  return luxonDate;
};

export const convert_Timestamp_To_Luxon_no_local_time = (timestamp, station) => {
  const date = new Date(parseInt(timestamp));
  const luxonDate = convert_DateFns_To_Luxon(date).setZone(getTimeZoneFromSwaStation(station));
  return luxonDate;
};

export function getFormattedTimeStamp(luxonDateTime) {
  return getShiftDate(luxonDateTime) + " " + getShiftTime(luxonDateTime);
}

export function format_DOW_ShortMonth_Date_Year(shift) {
  if (shift) {
    return shift.weekdayShort + " " + shift.monthShort + " " + shift.day + ", " + shift.year;
  }
  return "";
}

export function format_DOW_ShortMonth_Date_Year_DateFns(shift) {
  if (shift) {
    let fnsDate = format(shift.getTime(), "iii MMM dd, yyyy");
    return fnsDate;
  }
  return "";
}

export function format_LongMonth_Date_Year_Time(shift) {
  return shift.monthLong + " " + shift.day + ", " + shift.year + " " + getShiftTime(shift);
}

export function format_ShortDOW_Date(shift) {
  return shift.weekdayShort + " " + getShiftDate(shift);
}

export function set_time_to_midnight(luxonDate) {
  return luxonDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
}

export function set_time_to_end_of_day(luxonDate) {
  return luxonDate.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
}

export function convert_Luxon_To_DateFns(luxonDate) {
  if (luxonDate) {
    let fnsDate = format(new Date(luxonDate.year, luxonDate.month - 1, luxonDate.day), "iii MMM dd, yyyy");
    return fnsDate;
  }
  return null;
}

export function convert_DateFns_To_Luxon(dateFnsDate) {
  if (dateFnsDate) {
    let luxonDate = DateTime.fromMillis(dateFnsDate.getTime());
    return luxonDate;
  }
  return null;
}

export function serializeDateToRedux(luxonDateTime) {
  return luxonDateTime.toFormat("yyyy-MM-dd HH:mm:ss z");
}

export function deserializeDateFromRedux(reduxISOwithIANAZoneString) {
  return DateTime.fromFormat(reduxISOwithIANAZoneString, "yyyy-MM-dd HH:mm:ss z", { setZone: true });
}

export const parseRequestShiftTime = (startDateTime, EndDateTime) => {
  return getShiftTime(startDateTime) + "-" + getShiftTime(EndDateTime);
};

export const parsePreferredLeaveTime = (preferredWOPStartTime, preferredWOPEndTime) => {
  const dateTimeStart = DateTime.fromISO(preferredWOPStartTime, { setZone: true });
  const dateTimeEnd = DateTime.fromISO(preferredWOPEndTime, { setZone: true });
  return `${dateTimeStart.hour.toString().padStart(2, "0")}:${dateTimeStart.minute
    .toString()
    .padStart(2, "0")}-${dateTimeEnd.hour.toString().padStart(2, "0")}:${dateTimeEnd.minute
    .toString()
    .padStart(2, "0")}`;
};

export const convert_DateFns_To_Luxon_for_Station_TimeZone_at_Midnight = (date, station) => {
  if (date) {
    const stationTimeZoneDate = convert_DateFns_To_Luxon(date).setZone(getTimeZoneFromSwaStation(station), {
      keepLocalTime: true,
    });
    const dateSetToMidnight = set_time_to_midnight(stationTimeZoneDate);
    return dateSetToMidnight;
  }
  return null;
};

export const convert_DateFns_To_Luxon_for_Station_TimeZone_at_EndOfDay = (date, station) => {
  if (date) {
    const stationTimeZoneDate = convert_DateFns_To_Luxon(date).setZone(getTimeZoneFromSwaStation(station), {
      keepLocalTime: true,
    });
    const dateSetToEndOfDay = set_time_to_end_of_day(stationTimeZoneDate);
    return dateSetToEndOfDay;
  }
  return null;
};

export const isoDateStringToClientDateStringFormat = (isoDateString) => {
  const yearMonthDay = isoDateString.split("-");
  const year = yearMonthDay[0];
  const month = yearMonthDay[1];
  const day = yearMonthDay[2];
  return `${month}/${day}/${year}`;
};

export const convertIsoDateToLuxon = (isoDate) => {
  return DateTime.fromFormat(isoDate, "yyyy-MM-dd");
};

export const convertMonthStringToInteger = (monthString) => {
  return DateTime.fromFormat(monthString, "MMMM").month.toString().padStart(2, "0");
};
